import React from 'react';
import { Link } from 'react-router-dom';
import { useLandingPage } from './LandingPage/useLandingPage';
import HeroSection from './LandingPage/HeroSection';
import FiltersCard from './LandingPage/FiltersCard';
import TimeSlotGrid from './LandingPage/TimeSlotGrid';
import AvailabilityLegend from '../components/booking/AvailabilityLegend';

export default function LandingPage() {
  const f = useLandingPage();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-700 via-blue-800 to-blue-900">
      <HeroSection onLoginClick={() => f.navigate('/auth')} />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8 sm:py-12 landing-page-content bba-availability-panel">
        <div className="mb-6 sm:mb-8">
          <h2 className="text-3xl sm:text-4xl font-black font-heading uppercase mb-2 text-white">
            Check Availability
          </h2>
          <p className="text-base sm:text-lg text-blue-100">
            View real-time court availability and pricing
          </p>
        </div>

        <FiltersCard
          locations={f.locations}
          selectedLocation={f.selectedLocation}
          onLocationChange={f.handleLocationChange}
          selectedDate={f.selectedDate}
          setSelectedDate={f.setSelectedDate}
          minDate={f.minDate}
          maxDate={f.maxDate}
          isLocationClosed={f.isLocationClosed}
          getOperatingHoursDisplay={f.getOperatingHoursDisplay}
          getBreakInfo={f.getBreakInfo}
        />

        {f.selectedLocation && (
          <TimeSlotGrid
            selectedLocation={f.selectedLocation}
            isLocationClosed={f.isLocationClosed}
            timeSlots={f.timeSlots}
            loading={f.loading}
            availability={f.availability}
            pricing={f.pricing}
            isTimeSlotPast={f.isTimeSlotPast}
            onBook={f.handleBookSlot}
          />
        )}

        <AvailabilityLegend />
      </div>

      <div className="bg-primary text-primary-foreground py-8 mt-12 landing-bottom-safe">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <a
            href="https://www.facebook.com/brubballassociation/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 mb-3 opacity-90 hover:opacity-100 transition-opacity"
            style={{ color: '#AECFFF', fontWeight: 600, fontSize: '14px' }}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="#AECFFF" aria-hidden="true">
              <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
            </svg>
            facebook.com/brubballassociation
          </a>
          <p className="text-sm opacity-75">
            © 2026 Brunei Basketball Association. Book your basketball courts with ease.
          </p>
          <p className="mt-2">
            <Link
              to="/terms"
              data-testid="footer-terms-link"
              className="text-xs transition-opacity opacity-50 hover:opacity-80"
              style={{ color: '#AECFFF' }}
            >
              Terms &amp; Conditions
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
